// extracted by mini-css-extract-plugin
export var fadeInAnimation = "video-module--fadeInAnimation--508ff";
export var video = "video-module--video--6ab11";
export var videoText = "video-module--videoText--8ba58";
export var wrapper = "video-module--wrapper--0238b";